import WildLife from "../../assets/images/kashmir-tour-package.jpg";
import Spritual from "../../assets/images/landing/sprituals.jpg";
import Lakshadeep from "../../assets/images/landing/lakshadeep.jpg";
import AsiaCruise from "../../assets/images/landing/cruise.jpg";
import Itineries from "../../assets/images/kashmir-tour-package.jpg";
import DashboardLogo from "../../assets/images/dashboard.jpg";
import { FaHotel } from "react-icons/fa";
import { IoCarSportSharp } from "react-icons/io5";
import { GiHotMeal } from "react-icons/gi";
import { PiBinocularsBold } from "react-icons/pi";
import moment from "moment";
const packageDetailsList = [
  {
    packageName: "Feel Alive in Kashmir in Summer",
    imageUrl: WildLife,
    Duration: "3N Srinagar | Pahalgam | Gulmarg",
    startingFrom: "₹ 26999",
    Price: "₹ 23,999",
    EMIFrom: "₹ 4,756",
  },
  {
    packageName: "Unexplored Kashmir",
    imageUrl: Spritual,
    Duration: "N Gurez Valley | 4N Srinagar",
    startingFrom: "₹ 34999",
    Price: "₹ 30,999",
    EMIFrom: "₹ 5,923",
  },
  {
    packageName: "Hidden Gems of Kashmir",
    imageUrl: Lakshadeep,
    Duration: "1N Gurez Valley | 4N Srinagar",
    startingFrom: "₹ 32999",
    Price: "₹ 28,999",
    EMIFrom: "₹ 5,550",
  },
  {
    packageName: "Gorgeous Kashmir",
    imageUrl: AsiaCruise,
    Duration: "3N Srinagar | Gulmarg | Pahalgam",
    startingFrom: "₹ 26999",
    Price: "₹ 16,999",
    EMIFrom: "₹ 3,500",
  },
  {
    packageName: "Kashmir Special",
    imageUrl: Itineries,
    Duration: "3N Srinagar | Pahalgam | Gulmarg",
    startingFrom: "₹ 18999",
    Price: "₹ 14,999",
    EMIFrom: "₹ 3,256",
  },
  {
    packageName: "Kashmir Special",
    imageUrl: DashboardLogo,
    Duration: "3N Srinagar | Pahalgam | Gulmarg",
    startingFrom: "₹ 26999",
    Price: "₹ 19,999",
    EMIFrom: "₹ 3,906",
  },
];

const inclusions = [
  {
    icon: <FaHotel />,
    inclusionName: "Hotel",
  },
  {
    icon: <PiBinocularsBold />,
    inclusionName: "Sightseeing",
  },
  {
    icon: <IoCarSportSharp />,
    inclusionName: "Transfer",
  },
  {
    icon: <GiHotMeal />,
    inclusionName: "Meal",
  },
];
const packageTabs = [
  {
    label: "Overview",
    value: "Overview",
  },
  {
    label: "Day wise Itinerary",
    value: "Day wise Itinerary",
  },
  {
    label: "Inclusions/Exclusions",
    value: "Inclusions/Exclusions",
  },
  {
    label: "Calculate Price",
    value: "Calculate Price",
  },
  {
    label: "Terms & Conditions",
    value: "Terms & Conditions",
  },
];
const dayWiseList = [
  {
    label: 1,
    value: 1,
  },
  {
    label: 2,
    value: 2,
  },
  {
    label: 3,
    value: 3,
  },
  {
    label: 4,
    value: 4,
  },
  {
    label: 5,
    value: 5,
  },
  {
    label: 6,
    value: 6,
  },
];

const steps = [
  {
    day: "Day 1",
    value: 1,
    title: "Arrival at Srinagar",
    content:
      "Upon arrival at the Srinagar airport you will meet our representative and drive to Srinagar. After arrival check into hotel and also enjoy a 1 hr shikara ride in Dal Lake at Nehru Park on boulevard road, overnight stay in Hotel.",
  },
  {
    day: "Day 2",
    value: 2,
    title: "Excursion to Sonmarg",
    content:
      "After breakfast leave with a full day excursion for Sonmarg ‘The meadow of gold.’ Situated at an altitude of 9000 Ft. Sonmarg at a distance of 84 Kms from Srinagar is also called ‘The meadow of gold’. Sonmarg lies in Sindh Valley streamed with flowers and surrounded by mountains. The place is also the base for some interesting treks to the high altitude of Himalayan Lake. Ponies can be hired for the trip up to Thajiwas glacier, which is a major local attraction during the summer. Drive back from Sonmarg to Srinagar. Overnight stay in Hotel.",
  },
  {
    day: "Day 3",
    value: 3,
    title: "Trip to Gulmarg",
    content:
      "After breakfast drive to Gulmarg ‘Meadow of Flowers’ 2730 Mts. above sea level. The journey offers a scenic view of mountains and valleys. Overnight stay in Hotel.",
  },
];

const inclusionList = [
  {
    label: "Accommodation in mentioned base category rooms",
    value: "Accommodation in mentioned base category rooms",
  },
  {
    label: "Daily buffet breakfast & Dinner at all the hotels",
    value: "Daily buffet breakfast & Dinner at all the hotels",
  },
  {
    label: "All sightseeing and excursions as per the itinerary",
    value: "All sightseeing and excursions as per the itinerary",
  },
  {
    label: "Shikara Ride facility (01 Hour)",
    value: "Shikara Ride facility (01 Hour)",
  },
  {
    label: "All applicable taxes.",
    value: "All applicable taxes.",
  },
];

const exclusionList = [
  {
    label: "Any Airfare",
    value: "Any Airfare",
  },
  {
    label: "5% GST",
    value: "5% GST",
  },
  {
    label:
      "Any Kind of Personal Expenses or Optional Tours / Extra Meals Ordered",
    value:
      "Any Kind of Personal Expenses or Optional Tours / Extra Meals Ordered",
  },
  {
    label:
      "Anything not specifically mentioned under the head “Prices included”",
    value:
      "Anything not specifically mentioned under the head “Prices included”",
  },
  {
    label:
      "The Services of Vehicle is not included on leisure days & after finishing the sightseeing tour as per the",
    value:
      "The Services of Vehicle is not included on leisure days & after finishing the sightseeing tour as per the",
  },
];
const roomTypeList = [
  {
    label: "Room 1",
    _id: "room1",
    roomTypes: [
      {
        typeName: "Adult",
        count: 0,
        age: "12+ yrs",
      },
      {
        typeName: "Child",
        subType: " (With bed)",
        count: 0,
        age: "Below 12yrs",
      },
      {
        typeName: "Child",
        subType: " (Without bed)",
        count: 0,
        age: "Below 12yrs",
      },
      {
        typeName: "Infant",
        count: 0,
        age: "0-2yrs",
      },
    ],
  },
];

const termsConditions = [
  {
    label: "Travel Validity",
    _id: "Travel Validity",
    terms: [
      {
        termsName: `The deal is valid for travel till ${moment()
          .add(1, "year")
          .format("Do MMMM YYYY")}`,
      },
    ],
  },
  {
    label: "Easy Cancellation",
    _id: "Easy Cancellation",
    terms: [
      {
        termsName:
          "31 days or more prior to departure date Initial Booking Amount will be forfeited. Between 30–16 days: 75% of total tour cost will be charged as penalty. Less than 15 days: 100% of total tour cost will be charged as penalty.",
      },
    ],
  },
  {
    label: "Guaranteed Dates",
    _id: "Guaranteed Dates",
    terms: [
      {
        termsName:
          "Your selected travel dates are guaranteed. In the unlikely event of seats sold out, we guarantee +/- 1/2 days from your preferred dates.",
      },
    ],
  },
  {
    label: "High Season",
    _id: "High Season",
    terms: [
      {
        termsName: "Prices can fluctuate during peak season dates.",
      },
    ],
  },
  {
    label: "Booking Policy",
    _id: "Booking Policy",
    terms: [
      {
        termsName:
          "All services including the hotel and room category are subject to availability at the time of booking.",
      },
      {
        termsName:
          "30 days prior to the departure date - 75% of the remaining tour cost.",
      },
      {
        termsName:
          "15 days prior to the departure date - 100% of the tour cost required.",
      },
      {
        termsName:
          "Please Note: For issuance of the flight tickets, we require full payment of airfare.",
      },
      {
        termsName:
          "Please Note: Non-refundable services in the tour package have to be paid in full at the time of booking.",
      },
      {
        termsName:
          "Please Note: Payment policy is non-negotiable and has to be paid accordingly.",
      },
    ],
  },
  {
    label: "Remarks",
    _id: "Remarks",
    terms: [
      {
        termsName: "Limited Time Deal",
      },
    ],
  },
];

export {
  packageDetailsList,
  inclusions,
  packageTabs,
  inclusionList,
  exclusionList,
  roomTypeList,
  termsConditions,
  dayWiseList,
  steps,
};
